__turbopack_context__.v({
  "group": "ui-search-banner-group-module__fhAjxG__group",
});
